import React from 'react';
//import useReactRouter from 'use-react-router';
import {Link} from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
//import div from '@mui/material/div';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
//import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Divider from '@mui/material/Divider';
//import Button from '@mui/material/Button';

import PersonIcon from '@mui/icons-material/Person';
//import PaidIcon from '@mui/icons-material/Paid';
import FaceIcon from '@mui/icons-material/Face';
//import UploadFileIcon from '@mui/icons-material/UploadFile';
//import CreditScoreIcon from '@mui/icons-material/CreditScore';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PublicIcon from '@mui/icons-material/Public';
import AnnouncementIcon from '@mui/icons-material/Announcement';
//import SecurityIcon from '@mui/icons-material/Security';
//import PageTitle from './PageTitle';
//import MultiLines from './MultiLines';
import NotFound from './NotFound';
//import {useStyles} from './useStyles';
//import {MinMinAmount,MaxMinAmount,TransferFee,MaxProducts} from './Inc';
//import Tools from './Tools';
//import ProductDetail from './ProductDetail';
import Title from './Title';
import {HelpDict,HelpRelation,HelpData,HelpGroupName} from './GuideDict';
import useStyles from './Styles';

interface GuideDetailProps {
	dict: HelpDict,
    id: string,
	group: string,
}

const GuideDetail:React.FC<GuideDetailProps> = (props)=> {
	let index = -1;
	if( props.dict[props.group] ){
		for( let i=0;i<props.dict[props.group].length;i++ ){
			if( props.dict[props.group][i].id===props.id ){
				index = i;
			}
		}
	}
	const HelpText = (props: {text: string})=>{
		let table = false;
		let tr = true;
		let lines = [] as string[];
		props.text.replace(/\r\n/g,"\n").replace(/\r/g,"\n").split("\n").forEach((line:string,index:number)=>{
			//const key = "line"+index;
			if( line.substring(0,6)==="table:" ) {
				if( line.length>6 && line.substring(6,14)==="caption:"){
					line = "<table class='helpTable'><caption>"+line.substring(14)+"</caption>";
				} else {
					line = "<table class='helpTable'>";
				}
				table = true;
			} else if( line==="tr:" ){
				if( tr ){
					line = "</tr><tr>"
				} else {
					if(!table){
						line = "<table class='helpTable'><tr>";
						table = true;
					} else {
						line = "<tr>"
					}
				}
				tr = true;
			} else if( line.substring(0,3)==="td:" ){
				if( line.substring(3,5)==="c:" ){
					line = "<td class='c'>"+line.substring(5)+"</td>";
				} else if( line.substring(3,5)==="r:" ){
					line = "<td class='r'>"+line.substring(5)+"</td>";
				} else if( line.substring(3,5)==="l:" ){
					line = "<td class='l'>"+line.substring(5)+"</td>";
				} else {
					line = "<td>"+line.substring(3)+"</td>";
				}
			} else if( line.substring(0,3)==="th:" ){
				line = "<th>"+line.substring(3)+"</th>";
			} else if( line.substring(0,4)==="img:" ){
				line = "<div class='img'><img src='"+line.substring(4)+"'></div>";
			} else if( line.substring(0,8)==="https://" ){
				line = "<a href='"+line+"' target='_blank' rel='noreferrer noopener' class='link'>"+line+"</a>";
			} else {
				if( table ){
					if( line==="" ){
						line = "<br/>";
					}
					if( tr ){
						line = "</tr></table>" + line;
						tr = false
					} else {
						line = "</table>" + line;
					}
					table = false;
				} else {
					line = line+"<br/>";
				}
			}

			line = line.replace(/&lt;/g,"<");
			line = line.replace(/&gt;/g,">");
			line = line.replace(/&quot;/g,'"');

			lines.push(line);
		})
		return (
			<div dangerouslySetInnerHTML={{ __html: lines.join("") }}></div>
		)
	}
	const classes = useStyles();
	const data = props.dict[props.group][index]

	if( index<0 ){
		return <NotFound/>
	}
	
	return (
		<div id="guide" className={classes.root}>
			<Grid container spacing={1}>
				<Grid item xs={12} sm={8}>
					<Paper className={classes.paper}>
					<h3 style={{color:'teal',padding:'0 1em',marginTop:'0'}}>
						{props.group==='account' && <PersonIcon style={{verticalAlign:'middle',marginRight:'0.25em'}}/>}
						{props.group==='profile' && <FaceIcon style={{verticalAlign:'middle',marginRight:'0.25em'}}/>}
						{props.group==='transfer' && <ReceiptIcon style={{verticalAlign:'middle',marginRight:'0.25em'}}/>}
						{props.group==='promotion' && <PublicIcon style={{verticalAlign:'middle',marginRight:'0.25em'}}/>}
						{data.title}
					</h3>
					<div className="helpText">
						<HelpText text={data.body}/>
					</div>
					<Divider/>
					{data.relations.length>0 &&
					<div>
						<List
							subheader={
								<ListSubheader component="div" id="nested-list-subheader" classes={{root:classes.listSubHeader}}>
									関連記事
								</ListSubheader>
							}
						>
						{data.relations.map((relation:HelpRelation,index:number)=>{
							const key = "relation" + index;
							let relationIndex = -1;

							if( props.dict[relation.group_id] ){
								for( let i=0; i<props.dict[relation.group_id].length; i++ ){
									//console.log(props.dict[relation.group_id][i].id);
									if( props.dict[relation.group_id][i].id===relation.id ){
										relationIndex = i;
										break;
									}
								}
							}

							if( relationIndex<0 ){
								return (null);
							}

							const relationData = props.dict[relation.group_id][relationIndex];
							const to = '/help/'+relation.group_id+'/'+relation.id;
							return (
								<Link to={to} className="link" key={key}><ListItem dense>
									<ListItemText primary={relationData.title} classes={{primary:classes.helpListPrimaryOnly}}/>
									{relationData.notice &&
									<ListItemSecondaryAction><AnnouncementIcon className="newHelp"/></ListItemSecondaryAction>
									}
								</ListItem></Link>
							);
						})}
						</List>
					</div>
					}
					</Paper>
				</Grid>
				<Grid item xs={12} sm={4}>
					<Paper className={classes.paper}>
					<Title text="ヘルプ！" icon="store"/>
					<List
						subheader={
							<ListSubheader component="div" style={{lineHeight:'1em',marginBottom:'1em'}}>
								<Link to='/help' className="linkGrey">メニュー</Link> &gt; <span style={{color:'teal'}}>{HelpGroupName[props.group]}</span>
							</ListSubheader>
						}
						style={{marginTop:'0',paddingTop:'0'}}
					>
					{props.dict[props.group].map((data:HelpData,index:number)=>{
						const key = "menu" + index;
						const to = "/help/"+props.group+"/"+data.id;
						return (
							<Link to={to} className="link" key={key}><ListItem>
								<ListItemText primary={data.title} classes={{primary:classes.helpListPrimaryOnly}}/>
								{data.notice &&
								<ListItemSecondaryAction><AnnouncementIcon className="newHelp"/></ListItemSecondaryAction>
								}
							</ListItem></Link>
						)
					})}
					</List>
					</Paper>
				</Grid>
			</Grid>
		</div>
	)
}

export default GuideDetail;